"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ML_MODEL_FRAGMENT = void 0;
var client_1 = require("@apollo/client");
exports.ML_MODEL_FRAGMENT = (0, client_1.gql)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  fragment MLModel on MLModel {\n    id\n    modelType\n    version\n    namesBucketFileName\n    bucketFileName\n    dataset {\n      id\n    }\n  }\n"], ["\n  fragment MLModel on MLModel {\n    id\n    modelType\n    version\n    namesBucketFileName\n    bucketFileName\n    dataset {\n      id\n    }\n  }\n"])));
var templateObject_1;
